import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import TextIcon from '@mui/icons-material/TextFields';
import { SuiteTypes } from '../../../interfaces/SuiteTypes';

interface DialogShareProps {
  close: () => void;
  open: boolean;
  suites: SuiteTypes[]
}
export default function DialogShare({ close, open, suites }: DialogShareProps) {

  const [shareText, setShareText] = React.useState(false);

  const handleClose = () => {
    close()
    setShareText(false)
  };

  return (
    <React.Fragment>
      <Dialog
        open={open}
        onClose={handleClose}
        style={{ alignContent: 'center', justifyContent: 'center', alignItems: 'center' }}
      >
        <DialogTitle  >
          Exportar
        </DialogTitle>
        <DialogContent style={{ width: '100%', minWidth: 600, paddingBottom: 30, flexDirection: 'column', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>

          {!shareText &&
            <Button startIcon={<TextIcon />} onClick={() => setShareText(true)} autoFocus> Gerar Texto</Button>
          }

          {shareText &&
            suites.map((suite: SuiteTypes, index: number) =>
              <div key={index} style={{ width: '100%' }}>
                <br />
                <p
                  style={{
                    fontSize: 16,
                    fontWeight: 500,
                    textAlign: 'left',
                  }}
                >
                  <span style={{ fontWeight: 500 }}>Funcionalidade: </span>
                  {suite.title}
                </p>

                {suite.test_cases.map((test_case, subindex) =>
                  <>
                    <p key={subindex}
                      style={{
                        fontSize: 14,
                        fontWeight: "500",
                        textAlign: 'left',
                      }}
                    >
                      {test_case.title}
                    </p>

                    <p key={subindex}
                      style={{
                        fontSize: 12,
                        fontWeight: "400",
                        marginTop: -8,
                        textAlign: 'left',
                        whiteSpace: 'pre-wrap',
                        color: "gray"
                      }}
                    >
                      {test_case.steps}
                    </p>

                    <p
                      key={subindex}
                      style={{ fontSize: 12, color: "gray", marginTop: -5, whiteSpace: 'pre-wrap' }}
                    >
                      <span style={{ fontWeight: 500 }}>Esperado: </span>
                      {test_case.expected_result}
                    </p>
                  </>
                )}

              </div>
            )
          }

        </DialogContent >

      </Dialog>
    </React.Fragment>
  );
}